import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/Home.vue'
import Login from './views/login/Login.vue'
import Advogado from './views/advogado/Advogado.vue'
import Escritorio from './views/escritorio/Escritorio.vue'
import Perfil from './views/perfil/Perfil.vue'
import Tipo from './views/tipo/Tipo.vue'
import Usuario from './views/usuario/Usuario.vue'
import Prazo from './views/prazo/Prazo.vue'
import Solicitacao from './views/prazo/Solicitacao.vue'
import Importacao from './views/prazo/Importacao.vue'
import TipoPendencia from './views/pendencia/TipoPendencia.vue'
import Relatorio from './views/relatorio/Relatorio.vue'
import MeuPerfil from './views/usuario/MeuPerfil.vue'
import Producao from './views/relatorio/Producao.vue'
import Pendencia from './views/prazo/Pendencia.vue'
import Catalogo from './views/catalogo/Catalogo.vue'
import ConfigEscritorio from './views/escritorio/ConfigEscritorio.vue'
import Financeiro from './views/relatorio/Financeiro.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/advogado',
      name: 'advogado',
      component: Advogado
    },
    {
      path: '/escritorio',
      name: 'Escritorio',
      component: Escritorio
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: Perfil
    },
    {
      path: '/tipo',
      name: 'Tipo',
      component: Tipo
    },
    {
      path: '/usuario',
      name: 'Usuario',
      component: Usuario
    },
    {
      path: '/prazo',
      name: 'Prazo',
      component: Prazo
    },
    {
      path: '/prazo/solicitacao',
      name: 'Solicitacao',
      component: Solicitacao
    },
    {
      path: '/prazo/:id',
      name: 'PrazoCad',
      component: Solicitacao
    },
    {
      path: '/tipopendencia',
      name: 'TipoPendencia',
      component: TipoPendencia
    },
    {
      path: '/importacao',
      name: 'Importacao',
      component: Importacao
    },
    {
      path: '/relatorio',
      name: 'Relatorio',
      component: Relatorio
    },
    {
      path: '/meuperfil',
      name: 'MeuPerfil',
      component: MeuPerfil
    },
    {
      path: '/Producao',
      name: 'Producao',
      component: Producao
    },
    {
      path: '/Pendencia',
      name: 'Pendencia',
      component: Pendencia
    },
    {
      path: '/catalogo',
      name: 'Catalogo',
      component: Catalogo
    },
    {
      path: '/configescritorio',
      name: 'ConfigEscritorio',
      component: ConfigEscritorio
    },
    {
      path: '/financeiro',
      name: 'Financeiro',
      component: Financeiro
    }
  ]
})
